export interface LoginCredentials {
    username: string;
    password: string;
    totptoken?: string;
    rememberDevice?: boolean;
    mfaMethod?: string;
}

export interface MfaData {
    selectedMfaMethod: string;
    availableMfaMethods: string[];
    mfaRequiredData: MfaRequiredData
    userId: string;
}

export interface MfaRequiredData {
    ticketId?: string,
    deviceNames?: [string];
}

export interface ResetMfaCredentials {
    mfarecoverycode: string;
    userId: string;
}

export interface LoginResult {
    userId: string;
    entrypoint: EntryPoint;
}

export interface EntryPoint {
    customDestinationUrl? : string,
    destination:
        "PAYROLL_DASHBOARD" |
        "PAYROLL_SELF_SERVICE_DASHBOARD" |
        "GRLD_DASHBOARD" |
        "TAXADVISOR_DASHBOARD" |
        "PAYROLL_CONSULTANT_BOARD" |
        "CUSTOM_DESTINATION";
}

export function defaultLoginCredentials(defaultUserName?: string | null): LoginCredentials {
    return {
        username: defaultUserName ? defaultUserName : "",
        password: ""
    }
}

export enum VariantType {
    SPARKASSE = "SPARKASSE",
    USERVOICE = "USERVOICE"
}

export class Variant {
    type? : VariantType

    static from(searchParams : URLSearchParams) : Variant | undefined {

        // 1. check variant parameter
        let variantSearchParam: string | null = searchParams.get("variant")
        let variant : Variant = new Variant();
        if (variantSearchParam && Object.keys(VariantType).includes(variantSearchParam)) {
            variant.type = variantSearchParam as VariantType;
            return variant
        }

        //2. check if uservoice SSO
        let userVoiceSearchParam: string | null = searchParams.get("uv_login")
        if (userVoiceSearchParam && userVoiceSearchParam === "1") {
            variant.type = VariantType.USERVOICE;
            return variant;
        }

        return undefined;
    }
}
